var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIco6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "outline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.058,32.281l-.535,1.644A2,2,0,0,0,30.6,36.161L32,35.145l1.4,1.017a1.972,1.972,0,0,0,2.353,0,1.971,1.971,0,0,0,.726-2.235l-.535-1.645,1.4-1.016a2,2,0,0,0-1.176-3.619H34.437L33.9,26h0a2,2,0,0,0-3.8,0l-.535,1.643H27.835a2,2,0,0,0-1.176,3.62Zm1.5-2.635a2,2,0,0,0,1.9-1.381L32,26.608l0,.012.534,1.646a2,2,0,0,0,1.9,1.38h1.728l-1.4,1.017A1.992,1.992,0,0,0,34.04,32.9l.534,1.646-1.4-1.017a2,2,0,0,0-2.352,0l-1.4,1.016L29.96,32.9a1.994,1.994,0,0,0-.727-2.236l-1.4-1.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.047,47.731l4.141-.953,2.074,3.71a1,1,0,0,0,.873.512h.046a1,1,0,0,0,.868-.594L32,43.752l2.951,6.653a1,1,0,0,0,.868.594h.046a1,1,0,0,0,.873-.512l2.074-3.71,4.141.953a1,1,0,0,0,1.139-1.379l-4.134-9.321a10,10,0,1,0-15.916,0l-4.134,9.321a1,1,0,0,0,1.139,1.379Zm20.406-2.4-2.923-.673a.994.994,0,0,0-1.1.486l-1.464,2.62-2.875-6.482.166-.373a9.959,9.959,0,0,0,5.211-2.3ZM24,31a8,8,0,1,1,8,8A8.009,8.009,0,0,1,24,31Zm1.529,7.61a9.948,9.948,0,0,0,5.525,2.342l-3.023,6.815-1.464-2.62a1,1,0,0,0-1.1-.486l-2.923.673Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 2,
    width: 2,
    x: 47,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 2,
    width: 2,
    x: 11,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 2,
    width: 2,
    x: 43,
    y: 13
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#fff",
    height: 2,
    width: 2,
    x: 51,
    y: 13
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56,9H8a1,1,0,0,0-1,1V54a1,1,0,0,0,1,1H56a1,1,0,0,0,1-1V10A1,1,0,0,0,56,9ZM55,53H9V19H55Zm0-36H9V11H55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIco6);
export default __webpack_public_path__ + "static/media/menu_ico_6.09c3238f59fea408ffbd966620c64529.svg";
export { ForwardRef as ReactComponent };